import {
  alpha,
  Box,
  Button,
  Checkbox,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Toolbar,
  Tooltip,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
  Snackbar,
} from '@mui/material';
import PropTypes from 'prop-types';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { visuallyHidden } from '@mui/utils';
import ApiService from '../../services/ApiService';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);

  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });

  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    columns,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead sx={{ width: '100%' }}>
      <TableRow>
        {/* <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              "aria-label": "select all desserts",
            }}
          />
        </TableCell> */}

        {columns.map((headCell) => (
          <TableCell
            key={headCell.laporanKejadianId}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={
              orderBy === headCell.laporanKejadianId ? order : false
            }
          >
            <TableSortLabel
              active={orderBy === headCell.laporanKejadianId}
              direction={orderBy === headCell.laporanKejadianId ? order : 'asc'}
              onClick={createSortHandler(headCell.laporanKejadianId)}
            >
              {headCell.label}
              {orderBy === headCell.laporanKejadianId ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

const EnhancedTableToolbar = (props) => {
  const { numSelected } = props;

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity
            ),
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Task List
        </Typography>
      )}

      {/* <Tooltip title="Delete">
        <Button
          variant="outlined"
          startIcon={<DeleteIcon />}
          onClick={() => alert("Delete Selected")}
          disabled={numSelected <= 0}
        >
          Delete
        </Button>
      </Tooltip> */}
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const TableAtas = ({ columns, EditData, DeleteData }) => {
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [id, setId] = useState(null);
  const [loading, setLoading] = useState(false);

  const [rows, setRows] = useState([]);

  const [totalRow, setTotalRow] = useState(null);

  // Fetch Data
  useEffect(() => {
    setLoading(true);

    ApiService.getTaskList({
      // page: 1,
      // itemPerPage: 100,
      page: page + 1,
      itemPerPage: rowsPerPage,
    })
      .then((res) => {
        let result = res.data.payload;
        // console.log("res", res);

        setRows(result.data);
        setTotalRow(result.pagination.totalCount);

        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  }, [page, rowsPerPage]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.laporanKejadianId);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  // Handle Select
  const isSelected = (id) => selected.indexOf(id) !== -1;

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * (rowsPerPage - rows.length)) : 0;

  // handle ganti halaman
  const handleChangePage = (event, newPage) => {
    // console.log("newPage", newPage);
    // Perbarui halaman
    setPage(newPage);
  };

  // handle ganti max row
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Handle menghapus LKP
  const handleRemoveLkp = () => {
    ApiService.deleteIncimanLkp(id)
      .then((response) => {
        if (response.data.payload) {
          const updatedData = rows.filter(
            (row) => !selected.includes(row.laporanKejadianId)
          );

          setRows(updatedData);
          window.location.reload();
          return;
        }

        setSnackbarMessage('Failed to delete data');
        setSnackbarOpen(true);
      })
      .catch((error) => {
        setSnackbarMessage('Failed to delete data');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setOpenDialog(false);
      });
  };

  // Dialog Confirmation
  const [openDialog, setOpenDialog] = React.useState(false);
  const handleClickOpenDialog = (id) => {
    setId(id);
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const handleSnackbarClose = () => {
    setSnackbarMessage(null);
    setSnackbarOpen(false);
  };

  return (
    <Paper>
      {/* Judul */}
      <EnhancedTableToolbar numSelected={selected.length} />

      <TableContainer>
        <Table sx={{ minWidth: '100%' }} aria-labelledby="tableTitle">
          <EnhancedTableHead
            columns={columns}
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={rows.length}
          />
          <TableBody>
            {loading ? (
              <div className="spinerr">
                <CircularProgress />
              </div>
            ) : null}

            {stableSort(rows, getComparator(order, orderBy)).map(
              (row, index) => {
                const isItemSelected = isSelected(row.name);
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <TableRow
                    hover
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.laporanKejadianId}
                    selected={isItemSelected}
                  >
                    {/* <TableCell padding="checkbox">
                      <Checkbox
                        color="primary"
                        onClick={(event) => handleClick(event, row.name)}
                        checked={isItemSelected}
                        inputProps={{
                          "aria-labelledby": labelId,
                        }}
                      />
                    </TableCell> */}
                    <TableCell>{row.nomorLaporan}</TableCell>
                    <TableCell>{row.judulLaporan}</TableCell>
                    <TableCell>
                      {moment(row.dateReported).format('DD MMM YYYY')}
                    </TableCell>
                    <TableCell>
                      <span
                        style={{
                          backgroundColor:
                            row.statusLaporan === 'Draft' ||
                            row.statusLaporan === 'draft'
                              ? '#E3E3ED'
                              : row.statusLaporan === 'Issued' ||
                                row.statusLaporan === 'issued'
                              ? '#FFCF03'
                              : row.statusLaporan === 'Verified' ||
                                row.statusLaporan === 'verified'
                              ? '#92D050'
                              : '',
                          borderRadius: '5px',
                          padding: '8px 25px',
                        }}
                      >
                        {row.statusLaporan}
                      </span>
                    </TableCell>
                    <TableCell>
                      {(row.statusLaporan === 'Draft' ||
                        row.statusLaporan === 'draft') && (
                        <Stack spacing={2} direction="row">
                          <IconButton
                            onClick={() => {
                              EditData(row.paramLkpEncode);
                              console.log(row.paramLkpEncode);
                            }}
                          >
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            onClick={() => {
                              handleClickOpenDialog(row.laporanKejadianId);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Stack>
                      )}
                    </TableCell>
                  </TableRow>
                );
              }
            )}

            {emptyRows > 0 && (
              <TableRow
                style={{
                  height: 53 * emptyRows,
                }}
              >
                <TableCell colSpan={6} />
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {rowsPerPage !== null && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRow}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}

      {/* Confirmation Message */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Apakah anda yakin ingin menghapus dokumen ini?'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Data yang sudah dihapus tidak bisa dikembalikan
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleRemoveLkp} autoFocus>
            Continue
          </Button>
        </DialogActions>
      </Dialog>

      {snackbarMessage && snackbarOpen && (
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={3000}
          onClose={handleSnackbarClose}
          message={snackbarMessage}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
        />
      )}
    </Paper>
  );
};

export default TableAtas;
